import create from '@verndale/core';
import 'focus-visible';
import { initializeDataLayerTracking } from './analytics/init';
import { initializeEmbedHeightMessenger } from './embed-height-messenger';
import { captureAttribution } from './helpers/cart-attribution';
import modules from './modules';

const isStorybook = !!document.getElementById('storybook-root');
const body = document.querySelector('body') as HTMLBodyElement;

initializeDataLayerTracking();

// Before anything can rewrite the URL: partner landing params have to be banked
// on the first paint of the tagged page, including a PDP opened in a new tab.
captureAttribution();

function initializeModules(): void {
  create(modules).then(() => {
    body.dataset.modulesLoaded = 'true';
  });
}

function observeStorybookRenders(): void {
  const storyRoot = document.getElementById('storybook-root');

  if (!storyRoot) return;

  let renderFrame: number | undefined;
  const scheduleModuleInitialization = (): void => {
    if (renderFrame !== undefined) {
      window.cancelAnimationFrame(renderFrame);
    }

    renderFrame = window.requestAnimationFrame(() => {
      renderFrame = undefined;
      initializeModules();
    });
  };
  const observer = new MutationObserver(mutations => {
    if (!mutations.some(mutation => mutation.addedNodes.length > 0)) return;

    scheduleModuleInitialization();
  });

  observer.observe(storyRoot, { childList: true });
  scheduleModuleInitialization();
}

function removeOptimizelyViewPlaceholderHash(): void {
  if (window.location.hash !== '#.' || !window.history.replaceState) return;

  const cleanUrl = `${window.location.pathname}${window.location.search}`;
  window.history.replaceState(window.history.state, document.title, cleanUrl);
}

removeOptimizelyViewPlaceholderHash();

document.addEventListener(
  'DOMContentLoaded',
  async () => {
    initializeEmbedHeightMessenger();

    if (isStorybook) {
      observeStorybookRenders();
    } else if (!body.dataset.modulesLoaded) {
      initializeModules();
    }
  },
  false
);
